<script lang="ts">
  import { container } from "tsyringe";
  import { type Customer } from "$src/domain/customers/Customer";
  import { ServiceTokens } from "$src/domain/ServiceTokens";
  import { CustomerService } from "$src/application/designs/customers/CustomerService";
  import { PagedResult } from "$src/domain/core/PagedResult";
  import * as Table from "$lib/components/ui/table";
  import * as Pagination from "$lib/components/ui/pagination";
  import LoadingIcon from "$src/presentation/defaults/loading-icon.svelte";
  import { getContext } from "svelte";
  import { ContextTokens } from "$src/presentation/contexts/ContextTokens";
  import type { AuthContext } from "$src/infrastructure/accounts/AuthContext";
  import MainTemplate from "$src/presentation/main/main-template.svelte";
  import { getCustomerInfo } from "$src/domain/customers/utils/customer-info-utils";

  let currentPage: number = 1;
  let { activeGroupStore }: AuthContext = getContext(ContextTokens.Auth);

  async function getCustomers(
    groupStoreId: number,
    pageNumber: number
  ): Promise<PagedResult<Customer>> {
    const customerService: CustomerService = container.resolve(
      ServiceTokens.CustomerService
    );
    const result = await customerService.getCustomersByRecentProjects(
      groupStoreId.toString(),
      "2500",
      pageNumber,
      3
    );
    return result;
  }

  function setPage(page: number) {
    currentPage = page;
  }
</script>

<MainTemplate>
  {#if $activeGroupStore}
    {#await getCustomers($activeGroupStore.groupStoreId, currentPage)}
      <LoadingIcon />
    {:then customerPage}
      <Table.Root>
        <Table.Caption>Derniers clients</Table.Caption>
        <Table.Header>
          <Table.Row>
            <Table.Head class="w-[100px]">Client</Table.Head>
            <Table.Head>Adresse</Table.Head>
            <Table.Head>Date de dernier projet</Table.Head>
            <Table.Head class="text-right">Ventes</Table.Head>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {#each customerPage.items as customer}
            <Table.Row>
              <Table.Cell class="font-medium"
                >{getCustomerInfo(customer)}</Table.Cell
              >
              <Table.Cell>Paid</Table.Cell>
              <Table.Cell>Credit Card</Table.Cell>
              <Table.Cell class="text-right">$250.00</Table.Cell>
            </Table.Row>
          {/each}
        </Table.Body>
      </Table.Root>

      <Pagination.Root
        count={customerPage.totalCount}
        perPage={customerPage.pageSize}
        page={currentPage}
        onPageChange={(page) => setPage(page)}
        let:pages
      >
        <Pagination.Content>
          <Pagination.Item>
            <Pagination.PrevButton />
          </Pagination.Item>
          {#each pages as page (page.key)}
            {#if page.type === "ellipsis"}
              <Pagination.Item>
                <Pagination.Ellipsis />
              </Pagination.Item>
            {:else}
              <Pagination.Item>
                <Pagination.Link {page} isActive={currentPage == page.value}>
                  {page.value}
                </Pagination.Link>
              </Pagination.Item>
            {/if}
          {/each}
          <Pagination.Item>
            <Pagination.NextButton />
          </Pagination.Item>
        </Pagination.Content>
      </Pagination.Root>
    {:catch error}
      <p style="color: red">{error.message}</p>
    {/await}
  {/if}
</MainTemplate>

<style>
</style>
